import styled from 'styled-components';

export const StyledWrapper = styled.div<{ $transparent?: boolean }>`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme, $transparent }) => $transparent ? 'transparent' : theme.colors.darkPurple}; 
  align-items: flex-start;
  min-height: 100vh;
  padding: ${({ theme }) => theme.spacing.lg}; 
`;

export const StyledContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: ${({ theme }) => theme.layout.formMaxWidth};
`;

export const LogoWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing.xl} 0;
  text-align: center; 
  width: 100%;
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: ${({ theme }) => theme.spacing.xxs} 0;
  }
`;

export const StyledLogoImage = styled.img<{ $clickable?: boolean }>`
  max-width: 120px;
  cursor: ${({ $clickable }) => $clickable ? 'pointer' : 'default'};
  transition: ${({ $clickable }) => $clickable ? 'opacity 0.2s ease' : 'none'};
  
  ${({ $clickable }) => $clickable && `
    &:hover {
      opacity: 0.8;
    }
  `}
`;

export const StyledNotice = styled.div`
  color: ${({ theme }) => theme.colors.textLight};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  padding: ${({ theme }) => theme.spacing.md};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  text-align: center;
  border: 1px solid ${({ theme }) => theme.colors.accent}; 
  border-radius: ${({ theme }) => theme.radii.md};
  background-color: rgba(0,0,0, 0.1); 
`;

export const StyledFormContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: ${({ theme }) => theme.spacing.xl}; 
  border-radius: ${({ theme }) => theme.radii.xxl};
`;


export const ContainerTitle = styled.h1` 
  font-weight: ${({ theme }) => theme.fontWeights.medium}; 
  font-size: ${({ theme }) => theme.fontSizes.md};
  line-height: 1.2; 
  text-align: center;
  color: ${({ theme }) => theme.colors.primary};
  padding-bottom: ${({ theme }) => theme.spacing.xl}; 
  margin-top: 0;
`;

export const InstructionText = styled.p`
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.textMuted};
  padding-bottom: ${({ theme }) => theme.spacing.md};
  margin-top: 0;
`;

export const ContentWell = styled.div`
  text-align: justify;
  /* height: 450px;
  /* overflow-y: scroll; 
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const LayoutSideBySide = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.lg}; 
  margin-bottom: ${({ theme }) => theme.spacing.md};

  & > *:not(.react-datepicker__tab-loop) { 
    flex: 1 1 calc(50% - (${({ theme }) => theme.spacing.lg} / 2));
    min-width: 0;
    box-sizing: border-box;
  }

  .react-datepicker__tab-loop {
    position: fixed; 
  }
`;

export const ButtonNextWrapper = styled.div` 
  display: flex;
  justify-content: flex-end;
  margin-top: ${({ theme }) => theme.spacing.lg};
  
  & > button {
    max-width: 120px;
    /* max-height: 40px; 
  }
`;

export const InputErrorText = styled.p`
  color: ${({ theme }) => theme.colors.errorRed};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  margin-top: ${({ theme }) => theme.spacing.xxs};
  margin-left: ${({ theme }) => theme.spacing.xs};
`;